import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-map-view',
  templateUrl: './map-view.component.html',
  styleUrls: ['./map-view.component.css']
})
export class MapViewComponent implements OnInit {

  @Input()
  LattitudeVal: string = '';
  @Input()
  LogitudeVal: string = '';
  gpsLoaction: string = '';

  constructor() { }

  ngOnInit() {
    this.GetAddress();
  }

  GetAddress() {
    var path = "https://www.google.com/maps/embed?origin=mfe&pb=!1m3!2m1!1s";
    path += this.LattitudeVal + "," + this.LogitudeVal;
    path += '!6i14!3m1!1sen!5m1!1sen';    
    path += "&zoom=15";
    //console.log(path);
    this.gpsLoaction = path;
  }

}
